import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type SaveDefaultViewRequest } from '../services/saveDeafultViewService'

export interface SaveDefaultViewObjectState {
  saveDefaultViewObject: SaveDefaultViewRequest | null
}

// Initial state of the slice
const initialState: SaveDefaultViewObjectState = {
  saveDefaultViewObject: null
}

// Slice to return from action
export const SaveDefaultViewObjectGlobalState = createSlice({
  name: 'SaveDefaultViewObjectGlobalState',
  initialState,
  reducers: {
    SaveDefaultViewObjectUpdateAction: (state: SaveDefaultViewObjectState, action: PayloadAction<any>) => {
      return {
        saveDefaultViewObject: action.payload
      }
    }
  }
})

// Actions to export
export const {
  SaveDefaultViewObjectUpdateAction
} = SaveDefaultViewObjectGlobalState.actions

export default SaveDefaultViewObjectGlobalState.reducer
